/**
 * @file 获取微信信息
 * @author Kody
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IWxInfo {
    scene_type: number;
    is_follower: number; // 是否关注了微信公众号
    scene_url: string; // 公众号关注二维码
}

export type IWxinfoRes = IResponse<IWxInfo>;

export interface IWxInfoInput {
    scene_id: string;
    logo?: string;
}

export const getWxInfo = (param: IWxInfoInput): Promise<IWxinfoRes> => {
    return fetchData(Api.GET_WX_INFO, param);
};

export const getWxUserInfo = (): Promise<IResponse<{ encrypt_student_id: string }>> => {
    return fetchData(Api.GET_WX_USER_INFO);
};
